import { render, staticRenderFns } from "./Dialog_Settlement.vue?vue&type=template&id=c2570080&scoped=true&"
import script from "./Dialog_Settlement.vue?vue&type=script&lang=js&"
export * from "./Dialog_Settlement.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_Settlement.vue?vue&type=style&index=0&id=c2570080&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2570080",
  null
  
)

export default component.exports